import React from 'react';
import { useSelector } from "react-redux";

export default function (props) {
    const user = useSelector(state => state.user);
    const access = user.perms.includes(props.permission);
    return access ? props.children : null;
}